// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__e-8MS","amount":"Amount_amount__1yfqI","tip":"Amount_tip__3lbw3","tipHeader":"Amount_tipHeader__10XhQ","tipsWrap":"Amount_tipsWrap__340uP"};